import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "phoneNumber",
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return "";
    }

    let newVal = value.replace(/\D/g, "");
    if (newVal.length === 0) {
      newVal = "";
    } else if (newVal.length <= 2) {
      newVal = newVal.replace(/^(\d{0,3})/, "$1");
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,4})/, "$1 $2");
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})/, "$1 $2 $3");
    } else {
      newVal = newVal.substring(0, 10);
      newVal = newVal.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})/, "$1 $2 $3");
    }

    return newVal;
  }

  parse(value: string): string {
    return value.replace(/\D/g, "");
  }
}
